"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAccountAccessGroupToJSON = exports.ClientAccountAccessGroupFromJSONTyped = exports.ClientAccountAccessGroupFromJSON = exports.ClientAccountAccessGroup = void 0;
/**
 * The access group of the client account.
 * @export
 */
exports.ClientAccountAccessGroup = {
    Public: 'PUBLIC',
    Internal: 'INTERNAL'
};
function ClientAccountAccessGroupFromJSON(json) {
    return ClientAccountAccessGroupFromJSONTyped(json, false);
}
exports.ClientAccountAccessGroupFromJSON = ClientAccountAccessGroupFromJSON;
function ClientAccountAccessGroupFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ClientAccountAccessGroupFromJSONTyped = ClientAccountAccessGroupFromJSONTyped;
function ClientAccountAccessGroupToJSON(value) {
    return value;
}
exports.ClientAccountAccessGroupToJSON = ClientAccountAccessGroupToJSON;
